import Application from '@core/classes/Applications/Application';
import CustomerRecord from '@core/classes/Customer/CustomerRecord';
import { defineStore } from 'pinia';
import { getInformationForCustomerPortal } from '@core/helpers/Customer/customer-helper';
import LogRocket from 'logrocket';
import { ref } from 'vue';
import { useBusinessStore } from '@core/stores/BusinessStore';
import { useCustomerApplicationStore } from '@core/stores/CustomerApplicationStore';
import { useCustomerStore } from '@core/stores/CustomerStore';

export const useUserStore = defineStore('user', () => {
	const customerData = ref(null);
	const businessData = ref(null);
	const customerAppData = ref(null);
	const isInitialLoading = ref(false);

	// Action to set data in both UserStore and CustomerStore
	const setCustomerData = (customer: CustomerRecord) => {
		customerData.value = customer;
		const customerStore = useCustomerStore();
		customerStore.customer = customer;
	};

	// Action to set data in both UserStore and BusinessStore
	const setBusinessData = (business: any) => {
		businessData.value = business;
		const businessStore = useBusinessStore();
		businessStore.business = business;
	};

	// Action to set data in both UserStore and CustomerAppStore
	const setCustomerAppData = (customerApp: Application) => {
		customerAppData.value = customerApp;
		const customerAppStore = useCustomerApplicationStore();
		customerAppStore.customerApplication = customerApp;
	};

	const initializeCustomerData = async (customerId: string) => {
		if (customerId == null) return;
		if (customerData.value) {
			isInitialLoading.value = false;
			return;
		}

		try {
			isInitialLoading.value = true;
			const response = await getInformationForCustomerPortal(customerId);
			if (response) {
				setCustomerData(response.customer);
				setCustomerAppData(response.customerApplication);
				setBusinessData(response.businessCustomer);

				LogRocket.track(`Customer_Portal_Entered`, {
					customerId: response.customer?.id,
					customerCell: response.customer?.cell,
					customerEmail: response.customer?.email,
					customerDob: response.customer?.dob,
					applicationId: response.customerApplication?.id,
					businessCustomerId: response.businessCustomer?.id,
				});
			}
		} catch (error) {
			LogRocket.error('Error loading customer data', error);
		} finally {
			isInitialLoading.value = false;
		}
	};

	return {
		customerData,
		businessData,
		customerAppData,
		isInitialLoading,
		setCustomerData,
		setBusinessData,
		setCustomerAppData,
		initializeCustomerData,
	};
});
